<template>
  <WdsButtonGhost
    class="hire-column-worker-information"
    data-test="hire-column-worker"
    @click="openPanel"
  >
    <WdsAvatarLabel :path="avatarPath" truncated>
      <HireActiveStatusLabel :status="column.activeStatus" xs />
      <template #subText>
        <WdsStack direction-row align-center gap-sm>
          <WdsText primary>
            {{ getWorkerDisplayName(column.worker.name) }}
          </WdsText>

          <WdsTooltip
            v-if="
              column?.recruiterOwnershipDays &&
              column?.recruiterOwnershipDays > 0 &&
              column?.recruiterOwnershipDaysLeft &&
              column?.recruiterOwnershipDaysLeft > 0
            "
            top
            :global="tableGlobals"
            data-test="hire-worker-managed-status"
          >
            <div><WdsIcon color="#0E0D12" name="group" weight="thick" :size="12" /></div>

            <template #tooltip-content>
              <WdsStack direction-column gap-sm>
                <WdsStack direction-column>
                  <div v-if="column?.recruiterManagesWorkers">{{ $t('Worker managed by') }}</div>
                  <div v-else>{{ $t('Ongoing ownership period for') }}</div>
                  <div>
                    <strong>{{ column?.recruiter?.name }}</strong>
                  </div>
                </WdsStack>
              </WdsStack>
            </template>
          </WdsTooltip>
        </WdsStack>
      </template>
    </WdsAvatarLabel>
  </WdsButtonGhost>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import {
  WdsStack,
  WdsAvatarLabel,
  WdsButtonGhost,
  WdsText,
  WdsTooltip,
  WdsIcon,
} from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import HireActiveStatusLabel from '@/components/Common/HireActiveStatusLabel.vue'
import { getAvatarPath } from '@/utils/avatar'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { getWorkerDisplayName } from '@/utils/worker'
import { useTableGlobalsSelector } from '@/components/GraphqlDataTable/injection'
import { useTablePanels } from '@/components/GraphqlDataTable/useTablePanels'

const { openWorkerDetailPanel } = useTablePanels()

const tableGlobals = useTableGlobalsSelector()

const HireAvatarColumn = graphql(`
  fragment HireAvatarColumn on Hire {
    id
    recruiter {
      name
    }

    recruiterOwnershipStartDate
    recruiterOwnershipDays
    recruiterOwnershipDaysLeft
    recruiterManagesWorkers

    worker {
      id
      name
      avatar
      email # for export purposes
    }
    activeStatus
  }
`)

const props = defineProps<{ row: FragmentType<typeof HireAvatarColumn> }>()
const column = computed(() => useFragment(HireAvatarColumn, props.row))

const openPanel = () => {
  openWorkerDetailPanel({
    workerAccountId: column.value.worker.id,
    viewerAccountId: currentAccount.globalId,
  })
}

const avatarPath = computed(() => getAvatarPath(column.value.worker.avatar, column.value.worker.id))
</script>

<style lang="scss">
.hire-column-worker-information {
  text-align: left;
}
</style>
